export default __webpack_public_path__ + "static/media/Hammer and Nail.b01a08d2.png";